import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-personal",
  "use": "icon-personal-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-personal\"><defs><style>#icon-personal .cls-1{fill:#77b4f2;}#icon-personal .cls-2{fill:#232a35;}</style></defs><title>7</title><circle class=\"cls-1\" cx=\"22\" cy=\"11.55\" r=\"10.45\" /><path class=\"cls-2\" d=\"M18.39,17.82A11.56,11.56,0,1,1,29.94,6.27,11.58,11.58,0,0,1,18.39,17.82Zm0-20.9a9.35,9.35,0,1,0,9.34,9.35A9.35,9.35,0,0,0,18.39-3.08Z\" transform=\"translate(3.61 5.29)\" /><path class=\"cls-2\" d=\"M39.28,38.71a1.1,1.1,0,0,1-1.1-1.1,19.8,19.8,0,0,0-39.59,0,1.1,1.1,0,0,1-1.1,1.1,1.1,1.1,0,0,1-1.1-1.1,22,22,0,0,1,44,0A1.11,1.11,0,0,1,39.28,38.71Z\" transform=\"translate(3.61 5.29)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/personal.svg
// module id = bQZw
// module chunks = 22